<template>
  <ElPopover 
    v-model:visible="visible"
    popper-class="confirm-popover"
    :placement="placement"
    :title="title"
    :trigger="trigger"
    :width="width"
    :disabled="disabled"
    :persistent="persistent"
  >
    <p class="confirm-popover__header">
      {{ message }}
    </p>
    <div 
      v-if="buttons" 
      class="confirm-popover__button-wrapper"
    >
      <ElButton 
        v-for="button in buttons"
        :key="button.type"
        class="btn btn-sm confirm-popover__button"
        :class="button.type ==='success' ? 'btn-outline-green' : button.type ==='danger' ? 'btn-outline-danger' : 'btn-outline-primary'"
        :type="button.type"
        @click.prevent="() => clickButtonHandler(button.click)"
      >
        {{ button.text }}
      </ElButton>
    </div>
    <template v-slot:reference>
      <div 
        class="confirm-popover__reference" 
        :class="{
          [wrapperClass]: wrapperClass
        }"
      >
        <slot />
      </div>
    </template>
  </ElPopover>
</template>

<script>
export default {
  name: 'Popover',
  data() {
    return {
      visible: false,
    };
  },
  props: {
    placement: {
      default: 'top',
      type: String,
    },
    title: {
      default: '',
      type: String,
    },
    trigger: {
      default: 'click',
      type: String,
    },
    width: {
      default: 200,
      type: Number,
    },
    message: {
      default: '',
      type: String,
    },
    buttons: {
      default: null,
      type: Array,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    persistent: {
      default: true,
      type: Boolean,
    },
    wrapperClass: {
      default: null,
      type: String,
    },
  },
  methods: {
    clickButtonHandler(handler) {
      this.visible = false;

      if (handler) {
        handler();
      }
    },
  },
};
</script>

<style lang="scss">
.confirm-popover {
  &__header {
    word-break: break-word;
  }

  &__button-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  &__button {
    outline: none;
    height: 34px;
    margin-left: 8px !important;
  }
}
</style>
